import { Button, Col, Typography } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import ResetPasswordDialog from "../components/ResetPasswordDialog";
import { useGuard } from "../Guard";
import { useEffect, useState } from "react";

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const guard = useGuard();
  const [searchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams.entries());
  const [seconds, setSeconds] = useState(3);
  const [ok, setOk] = useState(false);

  // Lifecycle

  useEffect(() => {
    guard.signOut();
  }, []);

  useEffect(() => {
    let i: any;
    if (ok) {
      i = setInterval(() => {
        if (seconds < 1) {
          clearInterval(i);
          navigate("/login", {
            replace: true,
          });
        } else {
          setSeconds((seconds) => seconds - 1);
        }
      }, 1000);
    }

    return () => {
      clearInterval(i);
    };
  }, [ok, seconds]);

  // Events

  function onComplete(): void {
    setOk(true);
  }

  function onCancel(): void {
    navigate("/login", {
      replace: true,
    });
  }

  return (
    <Col className="flex flex-1 flex-col items-center justify-center">
      {params.code && params.userUid && (
        <>
          <ResetPasswordDialog
            open
            code={params.code}
            userUid={params.userUid}
            onComplete={onComplete}
            onCancel={onCancel}
          />
          {ok && (
            <>
              <Typography.Text
                className="max-w-96 p-4 text-center"
                type="success"
              >
                Password successfully changed. You will be redirect to login
                page. You will redirect in {seconds}..
              </Typography.Text>
              <Button onClick={onCancel}>Sign In</Button>
            </>
          )}
        </>
      )}
      {!(params.code && params.userUid) && (
        <>
          <Typography.Text className="max-w-96 p-4 text-center" type="danger">
            Something went wrong, request new reset password link and try again.
          </Typography.Text>
          <Button onClick={onCancel}>Sign In</Button>
        </>
      )}
    </Col>
  );
}

export default ResetPasswordPage;
